import { render, staticRenderFns } from "./manageHome.vue?vue&type=template&id=24a71017&scoped=true&"
import script from "./manageHome.vue?vue&type=script&lang=ts&"
export * from "./manageHome.vue?vue&type=script&lang=ts&"
import style0 from "./manageHome.vue?vue&type=style&index=0&id=24a71017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a71017",
  null
  
)

export default component.exports